// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel from '../../model/get-company-by-external-id-and-event-identifier-async-request-model';
import GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO from '../dto/get-company-by-external-id-and-event-identifier-async-request-dto';
import dtoSchema from '../schemas/get-company-by-external-id-and-event-identifier-async-request-schema';

export default abstract class GetCompanyByExternalIdAndEventIdentifierAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  */
  externalId?: string;
  /**
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO>): GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel;
  static toModel(dto: DeepPartial<GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO> | undefined | null): GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO> | undefined | null): GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel | undefined {
    return dto ? new GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel> | GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel): GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
      eventIdentifier: unwrapped.eventIdentifier,
    } as GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyByExternalIdAndEventIdentifierAsyncRequestModel, can not map to GetCompanyByExternalIdAndEventIdentifierAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
